const NOT_A_STRING = 'not a string';
export { NOT_A_STRING };
